import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const LowEnergyIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-lowEnergy"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M32.4336,21 L29.1476,32.761 C29.1356,32.809 29.1986,32.838 29.2266,32.798 L37.3466,21 L32.4336,21 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M38.4866,0 L31.6546,0 C31.1937659,0 30.7866254,0.303504731 30.6562345,0.746833676 L25.2817781,18.6606374 L25.252816,18.7783754 C25.1367088,19.4050607 25.6251644,20 26.2786,20 L31.237,20 L27.9699745,32.5276097 C27.6659302,33.6422044 29.1578844,34.3422752 29.8277917,33.3889455 L45.6565067,10.6350624 L45.7161432,10.5403031 C46.0922814,9.86696596 45.6092565,9 44.8026,9 L37.185,9 L39.4834204,1.33936764 C39.6889037,0.671630707 39.1808753,0 38.4866,0 Z M37.196,2 L34.8987796,9.66063236 L34.8698173,9.77837121 C34.7537088,10.4050607 35.2421644,11 35.8956,11 L42.965,11 L31.265,27.82 L33.4862255,19.3033903 L33.5103703,19.1883325 C33.6029725,18.5762293 33.1252397,18 32.4796,18 L27.568,18 L32.368,2 L37.196,2 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
